import { render, staticRenderFns } from "./AccountStatement.vue?vue&type=template&id=6727db96&scoped=true&"
import script from "./AccountStatement.vue?vue&type=script&lang=js&"
export * from "./AccountStatement.vue?vue&type=script&lang=js&"
import style0 from "./AccountStatement.vue?vue&type=style&index=0&id=6727db96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6727db96",
  null
  
)

export default component.exports